import { createEntityQuery } from '../../createEntityQuery';
import { PershingSsoService } from '@wealthlane/api-services/wealthlane-identity-service';

export const PERSHING_ELIGIBLE_KEY = ['pershingSsoEligibility'];

const useQuery = createEntityQuery<boolean, void>({
  queryKey: PERSHING_ELIGIBLE_KEY,
  queryFn: async () => {
    try {
      const res: any =
        await PershingSsoService.postApiIdentityApiAppPershingSsoCheckEligibility();
      return res?.isEligible ?? false;
    } catch {
      return false;
    }
  },
  options: { staleTime: Infinity },
});

export function useGetPershingEligibility() {
  return useQuery();
}
